import template from './insuranceNotesTemplates.html';
import controller from './insuranceNotesTemplatesCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
